import { api } from './api';

export interface JustificativaAusencia {
  id: string;
  id_militar: string;
  data_inicio: string;
  data_fim: string;
  motivo: string;
  ativo: boolean;
  criado_em: string;
  alterado_em: string;
  militar?: {
    id: string;
    nick: string;
    patente?: { patente: string; abreviacao: string; categoria: string };
    sigla?: { sigla: string };
  };
}

export interface AbrirJADTO {
  data_inicio: string;
  data_fim: string;
  motivo: string;
}

export const justificativasAusenciaService = {
  async listar(): Promise<JustificativaAusencia[]> {
    const response = await api.get('/justificativas-ausencia');
    return response.data;
  },

  async abrir(data: AbrirJADTO): Promise<JustificativaAusencia> {
    const response = await api.post('/justificativas-ausencia', data);
    return response.data;
  },

  async inativar(id: string): Promise<JustificativaAusencia> {
    const response = await api.patch(`/justificativas-ausencia/${id}/inativar`);
    return response.data;
  },
};
